/**
 * Mock 配置
 * 完全匹配 ui/src/api/*.js 中的实际 URL 路径
 * 通过 src/config.js 中的 config.mock.enabled 控制开关
 */
 import MockAdapter from 'axios-mock-adapter'
 import Mock from 'mockjs'
 import config from '../config'
 import request from '../utils/request'  // mock request 实例，而非默认 axios
 import menuSys from './menu'
 import menuDef from './menudef.json'
 import modelsApi from './modelsApi.json'
 import permissions from './permissions.json'
 
 // 合并默认首页菜单（置于最前）与系统菜单
 const menu = [...menuDef, ...menuSys]
 
 // 仅当 config.mock.enabled 为 true 时才启用 mock
 const mockEnabled = config.mock && config.mock.enabled
 
 let mockAdapter = null
 
 if (mockEnabled) {
   mockAdapter = new MockAdapter(request, { delayResponse: config.mock.delay || 0 })
 }
 
 // 随机延迟（当 delay=0 时直接返回）
 const delay = () => {
   if (!mockEnabled || config.mock.delay === 0) return Promise.resolve()
   return new Promise(r => setTimeout(r, config.mock.delay))
 }
 
 if (mockEnabled) {
   // ==================== 认证 auth.js ====================
   // auth.js 使用 /auth/xxx（无 /sys 前缀）
   mockAdapter.onPost('/api/auth/login').reply(async (config) => {
     await delay()
     const { username, password } = JSON.parse(config.data)
     console.log("==========");
     if (username === 'admin' && password === 'admin123') {
       return [200, {
         code: 200,
         msg: '登录成功',
         data: {
           token: 'mock-token-admin-123456',
           user: { id: 1, username: 'admin', nickname: '管理员', avatar: '', roles: ['admin'],
            permissions: ['edu:student:list','edu:student:add','edu:student:edit'] }
         }
       }]
     }
 
     return [200, { code: 401, msg: '用户名或密码错误' }]
   })
 
   mockAdapter.onPost('/api/auth/logout').reply(async () => { await delay(); return [200, { code: 200, msg: '退出成功' }] })
 
   mockAdapter.onGet('/api/auth/info').reply(() => {
     return [200, {
       code: 200,
       data: {
         id: 1,
         username: 'admin',
         nickname: '管理员',
         phone: '13800138000',
         email: 'admin@example.com',
         deptId: 1,
         deptName: '技术部',
         status: 1,
         permissions: permissions,
         menus:menu,
       }
     }]
   })
 
   mockAdapter.onGet('/api/auth/captcha').reply(() => {
 
     console.log("======captcha");
     return [200, {
       code: 200,
       data: {
         key: 'mock-uuid-' + Date.now(),
         image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=='
       }
     }]
   })
 
   // ==================== 特殊接口（无法迁移到 JSON）====================
 
   // user: 分配角色
   mockAdapter.onPost('/api/sys/user/assign-roles').reply(async () => { await delay(); return [200, { code: 200, msg: '分配成功' }] })
 
   // role: 获取全部角色列表（固定数据）
   mockAdapter.onGet('/api/sys/role/all').reply(async () => {
     await delay()
     return [200, { code: 200, msg: '操作成功', data: [
       { id: '1000000000000000001', roleName: '超级管理员', roleKey: 'super_admin', orderNum: 1, status: 1, isDeleted: 0, remark: '拥有所有权限', createTime: '2026-04-04 03:26:42', updateTime: '2026-04-04 03:26:42' },
       { id: '1000000000000000002', roleName: '普通用户',   roleKey: 'common_user',  orderNum: 2, status: 1, isDeleted: 0, remark: '普通用户权限', createTime: '2026-04-04 03:26:42', updateTime: '2026-04-04 03:26:42' }
     ]}]
   })
 
   // role: 获取角色已绑定的菜单 ID 列表
   mockAdapter.onGet('/api/sys/role/menu-ids').reply(async () => { await delay(); return [200, { code: 200, data: [1, 2, 3, 4, 5] }] })
 
   // role: 分配菜单
   mockAdapter.onPost('/api/sys/role/assign-menus').reply(async () => { await delay(); return [200, { code: 200, msg: '分配成功' }] })
 
   // dict: 字典项查询（按 code 返回下拉选项）
   mockAdapter.onGet('/api/sys/dict/items').reply(async () => { await delay(); return [200, { code: 200, data: [{ label: '正常', value: 1 }, { label: '禁用', value: 0 }] }] })
 
   // notice: 发布公告
   mockAdapter.onPost('/api/sys/notice/publish').reply(async () => { await delay(); return [200, { code: 200, msg: '发布成功' }] })
 
   // social: 查询用户的第三方绑定列表（用户管理页按行调用）
   mockAdapter.onGet('/api/sys/social/bindings').reply(async () => { await delay(); return [200, { code: 200, data: [] }] })
   mockAdapter.onGet('/api/sys/social/my-bindings').reply(async () => { await delay(); return [200, { code: 200, data: [] }] })
   mockAdapter.onPost('/api/sys/social/unbind').reply(async () => { await delay(); return [200, { code: 200, msg: '解绑成功' }] })
   mockAdapter.onPost('/api/sys/social/self-unbind').reply(async () => { await delay(); return [200, { code: 200, msg: '解绑成功' }] })
 
   // oss: 激活配置 / 文件上传（非标准后缀，不能写入 JSON）
   mockAdapter.onPost('/api/sys/oss/config/activate').reply(async () => { await delay(); return [200, { code: 200, msg: '激活成功' }] })
   mockAdapter.onPost('/api/sys/oss/upload').reply(async () => {
     await delay()
     return [200, { code: 200, msg: '上传成功', data: { url: '/uploads/mock-file-' + Date.now() + '.jpg', fileName: 'mock-file.jpg', fileSize: 102400 } }]
   })
 
   // wxpay: 非标准后缀接口
   mockAdapter.onPost('/api/plugs/wxpay/config/activate').reply(async () => { await delay(); return [200, { code: 200, msg: '激活成功' }] })
   mockAdapter.onGet('/api/plugs/wxpay/order/query').reply(async () => { await delay(); return [200, { code: 200, data: { status: 'SUCCESS', amount: 100 } }] })
   mockAdapter.onPost('/api/plugs/wxpay/order/close').reply(async () => { await delay(); return [200, { code: 200, msg: '关闭成功' }] })
   mockAdapter.onPost('/api/plugs/wxpay/native').reply(async () => { await delay(); return [200, { code: 200, data: { codeUrl: 'weixin://wxpay/s/mock_qr_code', outTradeNo: 'mock_' + Date.now() } }] })
 
 // 👇 核心配置：每个模块 = 前缀 + 自己的字段
 const moduleConfigs = convertMockFields(modelsApi);
 
 // 👇 固定后缀（增加 tree）
 const suffixList = [
   "list",
   "tree",        // 👈 新增 树结构接口
   "detail",
   "save",
   "update",
   "submit",
   "remove",
   "export",
   "import",
   "export-template"
 ];
 
 // ==============================================
 // 下方自动生成所有接口，完全不用改！
 // ==============================================
 moduleConfigs.forEach(({ prefix, mockFields }) => {
   suffixList.forEach((suffix) => {
     const url = `${prefix}/${suffix}`;
 
     // list 接口：用当前模块的 mockFields 生成数据
     if (suffix === "list") {
       mockAdapter.onGet(url).reply(async () => {
         await delay();
         return [
           200,
           {
             code: 200,
             data: {
               records: Mock.mock({ "list|10": [mockFields] }).list,
               total: 30
             }
           }
         ];
       });
       return;
     }
 
     // 👇 新增：tree 接口（自动生成无限层级树）
     if (suffix === "tree") {
       mockAdapter.onGet(url).reply(async () => {
         await delay();
         // 生成树结构：最大3层，每层最多3个子节点
         const treeData = generateMockTree(mockFields, 3, 3);
         return [200, { code: 200, data: treeData }];
       });
       return;
     }
 
     // detail 接口：自动生成单条数据
     if (suffix === "detail") {
       mockAdapter.onGet(url).reply(async () => {
         await delay();
         return [
           200,
           { code: 200, data: Mock.mock(mockFields) }
         ];
       });
       return;
     }
 
     // 其他接口通用
     const method = ["export", "detail", "list", "tree", "export-template"].includes(suffix)
       ? "onGet"
       : "onPost";
 
     mockAdapter[method](url).reply(async () => {
       await delay();
       return [200, { code: 200, msg: getMsg(suffix) }];
     });
   });
 });
 
 // 提示信息
 function getMsg(suffix) {
   const map = {
     save: "新增成功",
     update: "更新成功",
     submit: "提交成功",
     remove: "删除成功",
     export: "导出成功",
     import: "导入成功",
     "export-template": "模板导出成功"
   };
   return map[suffix] || "操作成功";
 }
 
 // 👇 核心：把 JSON 转成 Mock 支持的对象
 function convertMockFields(jsonConfig) {
   return jsonConfig.map(module => {
     const mockFields = {}
 
     // 遍历字段，逐个处理
     Object.entries(module.mockFields).forEach(([key, val]) => {
       // 1. 处理数组随机："[0,1]" → "key|1": [0,1]
       if (typeof val === 'string' && val.startsWith('[') && val.endsWith(']')) {
         mockFields[`${key}|1`] = JSON.parse(val)
       }
       // 2. 处理正则："regexp:1[3-9]\\d{9}" → /1[3-9]\d{9}/
       else if (typeof val === 'string' && val.startsWith('regexp:')) {
         const regStr = val.replace('regexp:', '')
         mockFields[key] = new RegExp(regStr)
       }
       // 3. 普通字段直接保留
       else {
         mockFields[key] = val
       }
     });
 
     return {
       prefix: module.prefix,
       mockFields
     };
   });
 }
 
 // ==============================================
 // 👇 新增：通用 Mock 树生成工具函数（自动使用你的 mockFields）
 // ==============================================
 function generateMockTree(nodeTemplate, maxLevel = 3, maxChildren = 3, currentLevel = 1, parentId = 0) {
   if (currentLevel > maxLevel) return [];
 
   const result = [];
   const childCount = Math.floor(Math.random() * maxChildren) + 1;
 
   for (let i = 0; i < childCount; i++) {
     // 用 Mock.js 生成单条数据
     const node = Mock.mock(nodeTemplate);
 
     // 自动补全树结构必须字段（不覆盖你已有的字段）
     node.id = node.id || Date.now() + Math.floor(Math.random() * 10000);
     node.parentId = parentId;
     node.label = node.label || `节点_${currentLevel}_${i + 1}`;
 
     // 递归生成子节点
     const children = generateMockTree(nodeTemplate, maxLevel, maxChildren, currentLevel + 1, node.id);
     if (children.length) node.children = children;
 
     result.push(node);
   }
   return result;
 }
 }
 
 export default mockAdapter